import { Box, Button, Typography } from "@mui/material";
import React from "react";
import theme from "../../theme";
import { StyledSpan } from "../../pages/orderMember/singleMember";

interface titleData {
  title?: string;
  title1?: string;
  description?: string;
  status?:any;
  isButton?: boolean;
  isSpan?: boolean;
  spanText?: string;
}

const TitleBar = (props: titleData) => {
  const { title, description, title1, isButton , status, isSpan, spanText} = props;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: isButton ? "30px" : "",
        textTransform:isSpan ? "capitalize" : "none",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          // paddingTop: 1,
          // paddingBottom: !description ? 1 : 3,
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "24px",
            color: theme.palette.myCustomColor.heading,
            whiteSpace: "break-spaces",
          }}
        >
          {title}{isSpan && <StyledSpan style={{marginLeft: "10px"}}>{spanText}</StyledSpan>} {" "}
          <span
            style={{
              fontWeight: 700,
              fontSize: "24px",
              color: "#060110",
              whiteSpace: "break-spaces",
            }}
          >
            {title1}
          </span>
        </Typography>
        <Typography variant="h4" sx={{ color: "#6C6F71" }}>
          {description}
        </Typography>
      </Box>
      {status && (
        <Button
          variant="contained"
          // onClick={handleClick}
          sx={{
            // background:
            //   btnTitle == "Completed"
            //     ? "#3DC826"
            //     : btnTitle == "Submitted"
            //     ? "#2977CC"
            //     : "#E7AB12",
            background: "#4CAF502E",
            width: 120,
            borderRadius: "27px",
            fontSize: "14px",
            FontWeight: 500,
            boxShadow: "none",
            whiteSpace: "nowrap",
            color: "#4CAF50",
          }}
        >
          Active
        </Button>
      )}
      {isButton && (
        <Button
          variant="contained"
          // onClick={handleClick}
          sx={{
            // background:
            //   btnTitle == "Completed"
            //     ? "#3DC826"
            //     : btnTitle == "Submitted"
            //     ? "#2977CC"
            //     : "#E7AB12",
            background: "#4CAF502E",
            width: 120,
            borderRadius: "27px",
            fontSize: "14px",
            FontWeight: 500,
            boxShadow: "none",
            whiteSpace: "nowrap",
            color: "#4CAF50",
          }}
        >
          Active
        </Button>
      )}
    </Box>
  );
};

export default TitleBar;
